MS = window.MS || {};

(function ($) {
  var $window = $(window);
  var $document = $(document);
  var $html = $("html");
  var $body = $("body");
  var CUSTOM_CURSOR_BREAKPOINT = 1200; // Desktop

  var MOBILE_NAV_OFFSET = 70;
  var MOBILE_MAX_BREAKPOINT = 860 - 1;

  MS.sultrysalt_hero = {
    $titles: null,
    player: null,
    duration: null,
    activeItem: null,
    currentTime: 0,
    playerActive: false,
    recipeTime: 0,
    recipeDuration: 0,
    recipeStatus: 0,
    playbackInterval: null,
    ctaInstance: {
      clicked: false,
      index: null,
      flagged: false,
    },
    PLAYER_VARS: {
      autoplay: 1,
      autohide: 1,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      controls: 0,
      loop: 1,
      disablekb: 1,
      enablejsapi: 1,
      iv_load_policy: 3,
      playsinline: 1,
    },
    PLAYER_VARS_RECIPE: {
      autoplay: 1,
      autohide: 1,
      modestbranding: 0,
      rel: 0,
      showinfo: 0,
      controls: 0,
      loop: 0,
      disablekb: 1,
      enablejsapi: 0,
      iv_load_policy: 3,
      playsinline: 1,
    },
    RECIPE_VIDEO_OFFSET: 0,
    segmentDuration: 5,
    segments: null,
    tiltDuration: 7,
    tilts: null,
    init: function () {
      var self = this;
      var that = MS.sultrysalt_hero;

      // Salt starting time from tilts video
      that.segments = [
        (that.segmentDuration + that.tiltDuration) * 0,
        (that.segmentDuration + that.tiltDuration) * 1,
        (that.segmentDuration + that.tiltDuration) * 2,
      ];

      // Tilt starting time from tilts video
      that.tilts = that.segments.map(function (segmentStart, index) {
        return segmentStart + that.segmentDuration;
      });

      that.isSingle = $body.hasClass("single");

      that.$element = $(".ms-ss_module__hero");
      that.$heroBase = that.$element.find(".hero");
      that.$titles = that.$element.find(".hero__title");
      that.$content = that.$element.find(".hero__content");

      // Video elements
      that.$saltsVideo = that.$element.find("#hero__video__salts");
      that.$tiltVideos = that.$element.find(".hero__video__tilt");
      // that.$tiltsVideo = that.$element.find('#hero__video__tilts');
      that.$recipeVideo = that.$element.find("#hero__plate_video");
      that.$recipeVideoContainer = that.$element.find(".hero__plate");

      // Video IDs
      that.saltsVideoID = that.$saltsVideo.data("videoId");
      // that.tiltsVideoID = that.$tiltsVideo.data('videoId');
      that.tiltVideoIDs = that.$tiltVideos
        .map(function (index, element) {
          return $(element).data("videoId");
        })
        .toArray();
      that.recipeVideoID = that.$recipeVideo.data("videoId");

      that.$recipeButton = that.$element.find(".hero__recipe-button");
      that.$verticalFacts = that.$element.find(".hero__vertical-facts");
      that.$playButton = that.$element.find("#video-controls__play");
      that.$playButtonIcon = that.$playButton.find('[class*="icon"]');
      that.$cta = that.$element.find(".hero__mobile-cta__button");

      // Share links
      function isMobile() {
        return "ontouchstart" in document.documentElement;
      }

      that.$socialBtn = that.$element.find(".js-social-btn");
      that.$socialList = that.$element.find(".header__social-dropdown");
      that.$fbShare = that.$element.find(".ms-trs-share-link.fb");
      that.$pnShare = that.$element.find(".ms-trs-share-link.pn");
      that.$twShare = that.$element.find(".ms-trs-share-link.tw");
      that.socialOpened = false;
      that.shareTouch = false;

      if (isMobile()) {
        that.$socialBtn.on("click", function () {
          that.shareTouch = true;
          if (that.$socialList.css("display") === "block") {
            that.socialOpened = false;
            that.$socialList.css("display", "none");
          } else {
            that.$socialList.css("display", "block");
            that.socialOpened = true;
          }
        });
      }

      that.$socialBtn.mouseenter(function () {
        if (!that.shareTouch && isMobile()) {
          return;
        }
        that.$socialList.css("display", "block");
      });

      that.$socialBtn.mouseleave(function () {
        that.$socialList.css("display", "none");
      });

      // Functions to call when YT Player API is ready
      that.onYTPlayerAPIReadyCallbacks = [that.loadRecipeVideo.bind(that)];

      if (!that.isSingle) {
        // For a sultrysalt landing page,
        // Load salts video
        that.onYTPlayerAPIReadyCallbacks.push(that.loadLoopVideos.bind(that));
      }

      // Run each callback when YT Player API is ready
      if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
        window.onYouTubeIframeAPIReady = function () {
          that.onYTPlayerAPIReadyCallbacks.forEach(function (callback) {
            callback();
          });
        };
      } else {
        that.onYTPlayerAPIReadyCallbacks.forEach(function (callback) {
          callback();
        });
      }

      // Check for custom cursor support
      this.checkCustomCursorSupport();

      // Bind elements events
      this.bindRecipeButton();
    },
    loadLoopVideos: function () {
      var that = this;

      // Load salts video if there is any
      if (this.$saltsVideo.length) {
        this.saltsPlayer = new YT.Player(this.$saltsVideo[0].id, {
          playerVars: $.extend({}, this.PLAYER_VARS, { loop: 1 }),
          events: {
            onReady: this.onSaltsPlayerReady.bind(this),
            onStateChange: this.onSaltsPlayerStateChange.bind(this),
          },
        });
        this.tiltPlayers = this.tiltVideoIDs.map(function (videoID, index) {
          var tiltPlayer = new YT.Player(that.$tiltVideos[index].id, {
            videoId: videoID,
            playerVars: $.extend({}, that.PLAYER_VARS, { loop: 1 }),
            events: {
              onStateChange: function (e) {
                that.onTiltPlayerStateChange(e, tiltPlayer);
              },
            },
          });
          return tiltPlayer;
        });
      }
    },
    loadRecipeVideo: function () {
      var self = this;
      var that = MS.sultrysalt_hero;

      // Load recipe video if there is any
      if (!that.$recipeVideo.length) {
        return;
      }

      that.recipePlayer = new YT.Player(that.$recipeVideo[0].id, {
        playerVars: that.PLAYER_VARS_RECIPE,
        events: {
          onReady: that.onRecipePlayerReady,
          onStateChange: that.onRecipePlayerStateChange,
        },
      });
    },
    onRecipePlayerReady: function () {
      var self = this;
      var that = MS.sultrysalt_hero;

      that.$recipeVideo = $(that.recipePlayer.getIframe());
      that.recipeVideoID = that.$recipeVideo.data("videoId");
      that.recipeDuration = that.recipePlayer.getDuration();
      that.recipeVideoController();
      that.onRecipeTimeUpdate();

      if (that.isSingle) {
        that.startRecipeVideo(true);
      }
    },
    showTiltVideo: function () {
      var selectedSaltIndex = this.activeItem;

      // Pause falling salt
      this.saltsPlayer.pauseVideo();

      // Play tilt video
      this.tiltPlayers[this.activeItem].playVideo();

      // Start time listening on the selected tilt player
      this.onTiltsTimeUpdate();
    },
    preloadRecipeVideo: function () {},
    startRecipeVideo: function (startImmediately) {
      var self = this;
      var that = MS.sultrysalt_hero;

      if (!that.$recipeVideo.length || !that.recipeVideoID) {
        return;
      }

      // Build video parameters
      var RECIPE_OBJ = {
        videoId: that.recipeVideoID,
        suggestedQuality: "highres",
      };

      if (startImmediately) {
        that.recipePlayer.preload = false;
      } else {
        that.recipePlayer.preload = true;
        that.recipePlayer.buffered = false;
      }

      // Load video
      that.recipePlayer.loadVideoById(RECIPE_OBJ);
      that.recipePlayer.mute();

      $(that.recipePlayer.a).addClass("active");

      // Track analytics event
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "recipeVideoView",
          videoID: that.recipeVideoID,
          videoData: that.recipePlayer.getVideoData(),
        });
      }
    },
    onSaltsPlayerReady: function () {
      var self = this;
      var that = MS.sultrysalt_hero;

      var VIDEO_OBJ = {
        videoId: that.saltsVideoID,
        suggestedQuality: "highres",
      };

      that.playerActive = true;

      that.bindTitleClick();
      that.saltsPlayer.loadVideoById(VIDEO_OBJ);
      that.saltsPlayer.playVideo();
      that.saltsPlayer.mute();

      that.$content.on("click", function () {
        if (that.socialOpened) {
          that.socialOpened = false;
          that.shareTouch = false;
          that.$socialList.css("display", "none");
        } else {
          that.loadRecipe();
        }
      });

      that.duration = that.saltsPlayer.getDuration();
      that.onTimeUpdate();
    },
    onSaltsPlayerStateChange: function (e) {
      var self = this;
      var that = MS.sultrysalt_hero;

      if (e.data === 1) {
        that.playing = true;
        that.onPlaying();
      } else {
        if (e.data === 0) {
          that.saltsPlayer.seekTo(that.segments[0]);
        }
        that.playing = false;
      }
    },
    /**
     * @param  {Object} e
     * @param  {Object} player  - YT.Player instance
     */
    onTiltPlayerStateChange: function (e, player) {
      var that = this;

      // Pause after initial play to force buffer
      if (!player.buffered && !that.ctaInstance.flagged && e.data === 1) {
        player.pauseVideo();
        player.buffered = true;
      }
    },
    onRecipePlayerStateChange: function (e) {
      var self = this;
      var that = MS.sultrysalt_hero;

      that.recipeStatus = e.data;

      // Ended
      if (e.data === 0) {
        that.recipePlayer.playing = false;
        that.endRecipeVideo();
      }
      // Playing
      else if (e.data === 1) {
        that.recipePlayer.playing = true;
        that.recipeVideoFinished = false;
        that.$playButtonIcon.removeClass("icon-play").addClass("icon-pause");

        // If requires preload, and not yet visible,
        // pause on initial play
        if (
          that.recipePlayer.preload &&
          !that.recipePlayer.buffered &&
          !that.recipeVideoVisible
        ) {
          that.recipePlayer.pauseVideo();
          that.recipePlayer.buffered = true;
        }

        // Pause also if persistent bar player is playing
        if (
          MS.sultrysalt_persistent_bar &&
          MS.sultrysalt_persistent_bar.atPlayableScroll
        ) {
          that.recipePlayer.pauseVideo();
          that.recipePlayer.buffered = true;
        }
      }
      // Paused
      else if (e.data === 2) {
        that.recipePlayer.playing = false;
        that.$playButtonIcon.removeClass("icon-pause").addClass("icon-play");
      }
    },
    loadRecipe: function () {
      var that = this;

      this.ctaInstance.clicked = true;

      if (!this.ctaInstance.flagged) {
        this.ctaInstance.flagged = true;
        // Update to show current active item title
        this.$content.attr("data-index", this.activeItem);
      }

      // update UI
      this.$element.addClass("video-selected");

      this.recipeVideoID = this.$titles
        .eq(this.activeItem)
        .data("recipeVideoId");
      this.showTiltVideo();
      this.startRecipeVideo();
      this.loadRecipeArticle();
    },
    endRecipeVideo: function () {
      var that = this;

      // Stop recipe player at first 2 seconds
      this.recipePlayer.seekTo(2);
      setTimeout(function () {
        that.recipePlayer.pauseVideo();
        that.recipeVideoFinished = true;
      }, 100);
    },
    onRecipeTimeUpdate: function () {
      var self = this;
      var that = MS.sultrysalt_hero;
      window.requestAnimationFrame(function () {
        that.recipeTime = that.recipePlayer.getCurrentTime();
        that.recipeDuration = that.recipePlayer.getDuration();
        that.updateVideoProgress();
        that.onRecipeTimeUpdate();

        // Instead of waiting for the recipe to end,
        // Wait until 0.5s before ending, then pause at starting frame
        if (
          that.recipeDuration &&
          that.recipeTime >= that.recipeDuration - 0.5
        ) {
          that.endRecipeVideo();
        }
      });
    },
    onTimeUpdate: function () {
      var self = this;
      var that = MS.sultrysalt_hero;

      if (!that.playerActive) {
        return;
      }

      if (that.playing) {
        that.currentTime = that.saltsPlayer.getCurrentTime();

        if (!that.ctaInstance.clicked) {
          // Determine which salt title to activate
          var targetIndex = Math.floor(that.currentTime / that.segmentDuration);

          // Activate title
          that.activateTitle(targetIndex);

          // Update salt title progress
          that.updateProgessBar();
        }
      }

      window.requestAnimationFrame(that.onTimeUpdate);
    },
    onTiltsTimeUpdate: function () {
      var that = this;
      var activeTiltsPlayer = that.tiltPlayers[that.activeItem];

      window.requestAnimationFrame(function () {
        var currentTiltTime = activeTiltsPlayer.getCurrentTime();

        if (!that.ctaInstance.flagged) {
          that.onTiltsTimeUpdate();
        }
        // Determine whether recipe tilt should end already
        else if (
          that.tiltDuration &&
          currentTiltTime >= that.tiltDuration - 0.1
        ) {
          // Flag state
          that.recipeVideoVisible = true;
          that.playerActive = false;
          that.$element.removeAttr("data-selected-index");
          that.recipePlayer.playVideo();
          activeTiltsPlayer.pauseVideo();
          setTimeout(function () {
            $body.addClass("recipe-video-visible");
            that.scaleRecipeVideo();
          }, 100);
        } else {
          that.onTiltsTimeUpdate();
        }
      });
    },
    scaleRecipeVideo: function () {
      var that = this;
      var heroHeight = this.$heroBase.outerHeight();
      var recipeVideoHeight = this.$recipeVideoContainer.outerHeight();
      var targetScaleRatio = heroHeight / recipeVideoHeight;

      // Determine translateX acc. to aspect ratio
      var viewportAspectRatio = window.innerHeight / window.innerWidth;

      // If aspect ratio is less than 16:9 (narrower landscape, or portrait)
      // add translate
      if (viewportAspectRatio > 9 / 16) {
        var transform =
          "translateZ(0) translateX(-50%) scale(" + targetScaleRatio + ")";

        // Add nav offset if mobile
        if (window.innerWidth <= MOBILE_MAX_BREAKPOINT) {
          transform =
            "translateZ(0) translateY(" +
            MOBILE_NAV_OFFSET +
            "px) " +
            transform;
        }

        // Apply new dimensions after transition
        this.$recipeVideoContainer.one("transitionend", function (e) {
          // Transitionend also fired by children, ensure this only fires for this element
          if (e.target !== that.$recipeVideoContainer[0]) {
            return;
          }
          that.onRecipeVideoScale();
        });

        // Scale down
        this.$recipeVideoContainer.css("transform", transform);
      } else {
        that.onRecipeVideoScale();
      }
    },
    onRecipeVideoScale: function () {
      $body.addClass("recipe-video-downscaled");
      this.$recipeVideoContainer.css("transform", "");
      // Recompute for scroll progress due to change in scroll amount
      MS.sultrysalt_scroll_progress.updateMetrics();
    },
    activateTitle: function (itemIndex) {
      var self = this;
      var that = MS.sultrysalt_hero;
      if (itemIndex === that.activeItem) {
        return;
      }

      $(".hero__cta__button").attr("data-index", itemIndex);

      that.$titles
        .filter(".active")
        // Remove active class
        .removeClass("active")
        // Remove progress bar transform
        .find(".hero__title__progress")
        .css("transform", "")
        .end()
        .end()
        // Active cuttent item
        .eq(itemIndex)
        .addClass("active");

      // Activate vertical descriptor accordingly
      that.$verticalFacts.attr("data-active-index", itemIndex);

      // update the recipe CTA link
      that.$cta.attr("href", that.$titles.eq(itemIndex).data("recipeLink"));

      that.activeItem = itemIndex;

      // update share links
      var postTitle = that.$titles.eq(itemIndex).data("recipeTitle");
      var postPermalink = that.$titles.eq(itemIndex).data("recipeLink");
      var saltImage = that.$titles.eq(itemIndex).data("recipeImage");

      that.$fbShare.attr(
        "href",
        "https://www.facebook.com/sharer/sharer.php?u=" +
          encodeURIComponent(postPermalink) +
          "&title=" +
          postTitle
      );

      that.$pnShare.attr(
        "href",
        "http://pinterest.com/pin/create/button/?url=" +
          encodeURIComponent(postPermalink) +
          "&media=" +
          encodeURIComponent(saltImage) +
          "&description=" +
          postTitle
      );

      that.$twShare.attr(
        "href",
        "https://twitter.com/share?text=" +
          postTitle +
          "&url=" +
          encodeURIComponent(postPermalink) +
          "&via=mortonsalt&hashtags=sultrysalt"
      );

      // update the titles collection
      that.$titles = $(".hero__title");
    },
    updateProgessBar: function () {
      var self = this;
      var that = MS.sultrysalt_hero;
      if (typeof that.activeItem !== "number") {
        return;
      }

      var $activeItem = that.$titles.eq(that.activeItem);
      var $activeProgressBar = $activeItem.find(".hero__title__progress");
      var progressRatio =
        (that.currentTime - that.segmentDuration * that.activeItem + 0.1) /
        that.segmentDuration;
      var progressPercent = 100 * (progressRatio >= 1 ? 1 : progressRatio);
      var progressRounded = Math.round(progressPercent / 5) * 5;

      $activeProgressBar.css(
        "transform",
        "translate3d(" + progressRounded + "%,0,0)"
      );
    },
    bindTitleClick: function () {
      var self = this;
      var that = MS.sultrysalt_hero;

      // Bind title clicks only if there is salts video
      if (that.$saltsVideo.length) {
        that.$titles.each(function (index) {
          $(this).click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass("active")) {
              that.loadRecipe();
            } else {
              that.saltsPlayer.seekTo(index * that.segmentDuration);
            }
          });
        });
      }
    },
    bindRecipeButton: function () {
      var $recipeArticle = $(".ms_ss_article");

      this.$recipeButton.on("click", function (event) {
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: $recipeArticle.offset().top,
          },
          1000
        );
      });
    },
    updateVideoProgress: function () {
      var self = this;
      var that = MS.sultrysalt_hero;

      that.recipeDuration = that.recipePlayer.getDuration();

      var recipeTime = that.recipeTime - that.RECIPE_VIDEO_OFFSET;
      var recipeDuration = that.recipeDuration - that.RECIPE_VIDEO_OFFSET;
      var percentage = (100 * recipeTime) / recipeDuration;
      var $progressBar = $(".hero__video-controls__timeline-progress");

      $progressBar.css("transform", "translate3d(" + percentage + "%,0,0)");
    },
    recipeVideoController: function () {
      var self = this;
      var that = MS.sultrysalt_hero;
      var $audioButton = $("#video-controls__audio");

      that.$playButton.on("click", function (e) {
        e.preventDefault();
        if (that.recipeStatus === 1) {
          that.recipePlayer.pauseVideo();
        } else if (that.recipeStatus === 2) {
          that.recipePlayer.playVideo();
        }
      });

      $audioButton.on("click", function (e) {
        e.preventDefault();
        if (that.recipePlayer.isMuted()) {
          that.recipePlayer.unMute();
          $audioButton
            .parents("div.hero__video-controls__audio-button")
            .removeClass("muted");
        } else {
          that.recipePlayer.mute();
          $audioButton
            .parents("div.hero__video-controls__audio-button")
            .addClass("muted");
        }
      });
    },
    onPlaying: function () {
      this.$element.addClass("disclosed");
    },
    hideSaltLoopControls: function () {
      var self = this;
      var that = MS.sultrysalt_hero;
    },
    loadRecipeArticle: function () {
      var that = this;
      var selectedSaltIndex = that.activeItem;
      var $selectedTitle = that.$titles.eq(selectedSaltIndex);
      var postID = $selectedTitle.data("defaultPost");
      var postTitle = $selectedTitle.data("recipeTitle");
      var postPermalink = $selectedTitle.data("recipeLink");

      // Add DOM cue
      that.$element.attr("data-selected-index", selectedSaltIndex);

      // Active nav link
      MS.sultrysalt_nav.activateByPermalink(postPermalink);
      // Fetch recipe contents
      MS.sultrysalt_recipe_transporter.loadRecipe(postID);
    },
    checkCustomCursorSupport: function () {
      var that = this;

      setTimeout(function () {
        // Bind mousemove/mouseenter in case custom cursor is not supported
        if (IS_IE || IS_EDGE) {
          that.startCustomCursorFallback();
        }
      }, 500);
    },
    startCustomCursorFallback: function () {
      var that = this;
      this.$customCursor = this.$element.find(".hero__custom-cursor");
      $body.addClass("no-custom-cursor");

      // Bind mousemove and mouseout
      this.$content
        .on("mousemove", function (e) {
          var $target = $(e.target);
          that.updateCursorPosition(e.clientX, e.clientY);
          if (
            $target.is(
              ".hero__title:not(.active), .hero__title:not(.active) span, .hero__mobile-cta__button *"
            )
          ) {
            e.stopPropagation();
            $body.removeClass("custom-cursor-activated");
          } else {
            // Show custom cursor
            $body.addClass("custom-cursor-activated");
          }
        })
        .on("mouseout", function (e) {
          $body.removeClass("custom-cursor-activated");
        });
    },
    updateCursorPosition: function (x, y) {
      var translate = [x + "px", y + "px", "0px"];
      this.$customCursor.css("transform", "translate3d(" + translate + ")");
    },
    replaceRecipeVideo: function (videoID) {
      this.recipeVideoFinished = false;
      this.$recipeVideo.attr("data-video-id", videoID);
      this.recipeVideoID = videoID;
      this.startRecipeVideo(true);
    },
  };
})(jQuery);
